import type { IdentifiedOrder } from '../models';

/** Todos los product_id del pedido (líneas sueltas y productos dentro de packs). */
export function extractProductIdsFromIdentifiedOrder(order: IdentifiedOrder): number[] {
  const ids = new Set<number>();
  for (const line of order.lines ?? []) {
    if (line.pack?.lines?.length) {
      for (const pl of line.pack.lines) {
        if (pl.product_id) ids.add(pl.product_id);
      }
    } else if (line.product_id) {
      ids.add(line.product_id);
    }
  }
  return Array.from(ids).sort((a, b) => a - b);
}
